// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"cc1039ab","147":"9fe9b391","156":"097d0179","438":"387cc76a","706":"38fe8824","726":"bc050865"}[chunkId] + ".chunk.js";
};